import script from "./time-proportion-classification.vue?vue&type=script&lang=ts&setup=true"
export * from "./time-proportion-classification.vue?vue&type=script&lang=ts&setup=true"

import "./time-proportion-classification.vue?vue&type=style&index=0&id=023bbef8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-023bbef8"]])

export default __exports__